export function ScrollMoreHint() {
  return (
    <div className="scroll-more-hint" aria-hidden="true">
      <svg viewBox="0 0 16 8" width="16" height="8" fill="none">
        <path d="M1.5 1l6.5 5.5L14.5 1" stroke="currentColor" strokeWidth="2"
              strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </div>
  );
}
